<template>
  <div class='indexbox'>
    <div class="tablebox">
      <div class="draggable" v-loading='loading'>
        <!-- //max-height='680px' -->
        <el-table :data="tableData" stripe border>
          <el-table-column prop="email" :label="$t('lg.操作人')" align='left' min-width='400' />
          <el-table-column prop="create_time" :label="$t('lg.操作时间')" align='left' sortable min-width='400' />
          <el-table-column prop="remark" :label="$t('lg.操作描述')" align='left' min-width='400' />
        </el-table>
      </div>
      <el-pagination @current-change='pagechage' @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100]"
        background layout="total,sizes,prev, pager, next" v-show="total > 0" :current-page.sync="page"
        :page-size="page_size" :total="total" />
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  export default {
    computed: {
      ...mapGetters(['api_id']),
    },
    data() {
      return {
        total: 0,
        page: 1,
        page_size: 10,
        tableData: [],
        loading: false,
      };
    },
    methods: {
      getlist() {
        this.loading = true
        this.$post({
          url: "/app/operate_log/logList",
          data: {
            page: this.page,
            page_size: this.page_size,
            api_id: this.api_id
          },
          success: (res) => {
            if (res.data.total) {
              this.tableData = res.data.data
              this.total = res.data.total
              this.page_size = Number(res.data.per_page)
              this.page = res.data.current_page
            }
            setTimeout(() => {
              this.loading = false
            }, 200);
          },
          tip: () => {
            this.loading = false
          },
        })
      },
      pagechage(page) {
        this.page = page
        this.tableData = []
        this.getlist()
      },
      handleSizeChange(size) {
        this.page_size = size
        this.tableData = []
        this.getlist()
      },
    },
    created() {
      this.getlist()
    },
  }
</script>
<style lang='scss' scoped>
  .indexbox {
    width: 100%;
    height: 100%;
    .searchbox {
      width: 100%;
      padding: 10px 20px 0px;
      background: #fff;
      border-bottom: 1px solid #babdcd;
      display: flex;
      justify-content: space-between;
      align-items: center;
      /deep/.el-row {
        width: 100%;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .right {
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }
      }
      /deep/.el-form {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .el-form-item {
          margin: 0 20px 10px 0 !important;
        }
      }
      /deep/.el-button {
        background-color: #d6f3e3;
        border-radius: 10px;
        color: #3b3b3b;
        border-color: #d6f3e3;
        align-self: flex-end;
      }
    }
    .tablebox {
      width: 100%;
      padding: 20px;
    }
    .formbox {
      /deep/.el-form-item {
        margin-bottom: 30px !important;
        .el-form-item__content {
          width: 100%;
          .el-button {
            width: 100%;
            height: 48px;
            background: $color;
            border-radius: 5px;
            border-color: $color;
          }
        }
      }
    }
  }
</style>